/**
 * 비교 화면용 사이드바 wrapper.
 *
 * 실제 접기/펴기 목차 UI는 도메인 중립 컴포넌트인 DocumentSidebar에 있다.
 * compare 화면의 기존 import 경로와 타입 이름을 유지하기 위한 얇은 alias layer.
 */

import {
  DocumentSidebar,
  type DocumentPeriodInfo,
  type DocumentSidebarCategory,
  type DocumentSidebarProps,
  type DocumentSidebarSection,
} from "@/components/document-sidebar";

export type PeriodInfo = DocumentPeriodInfo;
export type CompareSidebarSection = DocumentSidebarSection;
export type CompareSidebarCategory = DocumentSidebarCategory;
export type CompareSidebarProps = DocumentSidebarProps;

export const CompareSidebar = (props: CompareSidebarProps) => {
  return <DocumentSidebar {...props} />;
};
